export function scrollTo(element) {
    let offset = Math.min(90, document.querySelector('.header').offsetHeight) + 10;
    let position = element.getBoundingClientRect().top + document.documentElement.scrollTop - offset;
    if (typeof (jQuery) === 'undefined') {
        window.scroll({
            top: position,
            left: 0,
            behavior: "smooth",
        });
    } else {
        jQuery('html, body').animate({
            scrollTop: position
        }, 1000);
    }
}
